module.exports = __webpack_public_path__ + "static/media/back5.9baed9c3.png";